module.exports = __webpack_public_path__ + "pmchats-cover-5bd97e207ae878f3048a75318dc04a4c.webp";